import type React from 'react';

import { Page } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { CheckResultsProvider } from './checksResultContext';
import { ImageControl } from './image-checks-processing-image/ImageControl';
import st from './ImageChecksPage.module.sass';
import { ImagePageChecksBreadcrumbs } from './ImageChecksPageBreadcrumbs';
import { ImageChecksPageResults } from './ImageChecksPageResults';
import { useTaskData } from './useTaskData';

function ImageChecksPage(): React.JSX.Element | null {
  const { t } = useTranslation();
  const taskData = useTaskData();

  if (taskData.state !== 'fetched') return null;

  return (
    <div className={st.Content}>
      <CheckResultsProvider>
        <Page
          breadcrumbs={<ImagePageChecksBreadcrumbs />}
          className={st.Main}
          title={t('checks:image checks.page.title')}
        >
          <ImageControl taskData={taskData} />
        </Page>
        <ImageChecksPageResults taskData={taskData} />
      </CheckResultsProvider>
    </div>
  );
}

export { ImageChecksPage };
